import React from "react";

import styles from "./ChatEventCard.module.css"
import {EventType} from "../../../api/generated";
import classnames from "classnames";
import {BlackTooltip} from "../tooltip/BlackTooltip";
import {getChatOutcomeTitle} from "../../../utils/enumValueTitleUtil";

interface ChatEventCardProps {
    eventType: EventType
}

export const ChatEventCard: React.FC<ChatEventCardProps> = ({
                                                                eventType
                                                            }) => {

    const getEventCustomStyle = (): string => {
        switch (eventType) {
            case EventType.ReturnedUsedVehicleInformation:
            case EventType.ReturnedNewVehicleInformation:
                return styles.returnedVehicleInformation
            case EventType.ReturnedVehicleValuation:
                return styles.returnedVehicleValuation
            case EventType.ReservedVehicle:
                return styles.reservedVehicle
            case EventType.ReturnedFinanceQuote:
                return styles.returnedFinanceQuote
            case EventType.ReturnedFinanceApplication:
                return styles.returnedFinanceApplication
            case EventType.RequestedLimitedVehicleInformation:
                return styles.requestedLimitedVehicleInformation
            case EventType.RequestedLimitedVehicleValuation:
                return styles.requestedLimitedVehicleValuation
            case EventType.RequestedLimitedFinanceIllustration:
                return styles.requestedLimitedFinanceIllustration
            case EventType.RequestedLimitedVehicleReservation:
                return styles.requestedLimitedVehicleReservation
            default:
                throw new Error(`Unsupported chatEvent: ${eventType}`)
        }
    }

    const tooltipRequiredEvents = [
        EventType.RequestedLimitedVehicleInformation,
        EventType.RequestedLimitedVehicleValuation,
        EventType.RequestedLimitedFinanceIllustration,
        EventType.RequestedLimitedVehicleReservation
    ] as EventType[]

    const content = (
        <div className={classnames(styles.wrapper, getEventCustomStyle())}>
            {getChatOutcomeTitle(eventType)}
        </div>
    )

    return tooltipRequiredEvents.includes(eventType) ? (
        <BlackTooltip title={"Contact Sales to unlock now!"}>{content}</BlackTooltip>
    ) : (
        content
    )
}
